/*
 * Bakeology Studios — cart & product assist (additive, September 2026)
 * ---------------------------------------------------------------------
 * PRODUCT PAGE (only when the Dawn product form is in use; the Bakeology
 * cake configurator section handles its own sizes and is left alone)
 *   - Pre-selects the 6 x 6" size when the customer arrives without a
 *     ?variant= in the URL, so the price shown matches the "from $215" promise.
 *   - Rewrites the long size pill labels into a readable two-line form and
 *     tags the 6 x 6" as "Most popular". Radio values are untouched, so the
 *     theme's variant logic and the Globo options app keep working.
 * CART PAGE
 *   - Opens the Bird Pickup & Delivery widget on "Store Pickup" by default,
 *     so the date picker is the first thing a customer sees and the
 *     postcode gate only applies to people who actually want delivery.
 *   - When Check Out is refused by the widget, scrolls to the message,
 *     highlights it and shows a toast saying what is missing.
 * Safe by design: every step no-ops if the element it looks for is absent.
 */
(function () {
  'use strict';
  var tpl = window.bkTemplate || '';
  var GREEN = '#0E3A27', RED = '#B3261E';

  function css(text) { var s = document.createElement('style'); s.textContent = text; document.head.appendChild(s); }

  /* ---------------- toast (shared) ---------------- */
  var toastEl, toastTimer;
  function toast(msg, cta, onClick) {
    if (!toastEl) {
      css('#bk-assist-toast{position:fixed;left:50%;bottom:88px;z-index:100000;transform:translateX(-50%) translateY(18px);max-width:min(520px,calc(100vw - 32px));box-sizing:border-box;background:#E8E0D0;color:' + GREEN + ';border-left:5px solid ' + RED + ';padding:14px 18px;border-radius:10px;box-shadow:0 8px 28px rgba(0,0,0,.28);font-family:inherit;font-size:15px;line-height:1.45;display:flex;align-items:center;gap:14px;cursor:pointer;opacity:0;pointer-events:none;transition:opacity .22s ease,transform .22s ease}#bk-assist-toast.bk-visible{opacity:1;transform:translateX(-50%) translateY(0);pointer-events:auto}#bk-assist-toast b{white-space:nowrap;text-decoration:underline;font-weight:600}@media(max-width:749px){#bk-assist-toast{bottom:78px;font-size:14px;padding:12px 15px}}');
      toastEl = document.createElement('div'); toastEl.id = 'bk-assist-toast'; toastEl.setAttribute('role', 'alert');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span></span>' + (cta ? '<b></b>' : '');
    toastEl.firstChild.textContent = msg; if (cta) toastEl.lastChild.textContent = cta;
    toastEl.onclick = function () { if (onClick) onClick(); toastEl.classList.remove('bk-visible'); };
    toastEl.classList.add('bk-visible'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('bk-visible'); }, 7000);
  }

  /* ---------------- product page ---------------- */
  function product() {
    css('.product-form__input--pill{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
        '.product-form__input--pill legend{grid-column:1/-1}' +
        '.product-form__input--pill label{position:relative;display:block;width:100%;box-sizing:border-box;margin:0;padding:12px 14px;text-align:left;line-height:1.3;border-radius:12px}' +
        '.product-form__input--pill label .bk-size{display:block;font-size:1.5rem;letter-spacing:.02em}' +
        '.product-form__input--pill label .bk-serves{display:block;font-size:1.1rem;opacity:.7;margin-top:3px;text-transform:none;letter-spacing:0}' +
        '.product-form__input--pill label .bk-pop{position:absolute;top:-9px;right:10px;font-size:.95rem;letter-spacing:.14em;text-transform:uppercase;background:#D8B44A;color:' + GREEN + ';padding:3px 8px;border-radius:999px}' +
        '@media(max-width:749px){.product-form__input--pill{grid-template-columns:1fr}}');

    function prettify() {
      var labels = document.querySelectorAll('.product-form__input--pill label');
      labels.forEach(function (l) {
        if (l.getAttribute('data-bk')) return;
        var text = (l.textContent || '').replace(/\s+/g, ' ').trim();
        var m = text.match(/^(round|heart)\s+(\d)\s*x\s*(\d)"\s*\|\s*serves approx\.\s*([\d\-–]+)\s*dessert\s*\/\s*([\d\-–]+)\s*coffee/i);
        if (!m) return;
        var hidden = l.querySelector('.label-unavailable');
        var shape = m[1].charAt(0).toUpperCase() + m[1].slice(1);
        l.innerHTML = '<span class="bk-size">' + shape + ' ' + m[2] + '" × ' + m[3] + '"</span><span class="bk-serves">serves ' + m[4].replace('-', '–') + ' dessert · ' + m[5].replace('-', '–') + ' coffee</span>' +
          (m[2] === '6' && m[3] === '6' ? '<span class="bk-pop">Most popular</span>' : '');
        if (hidden) l.appendChild(hidden);
        l.setAttribute('data-bk', '1');
      });
    }

    function preselect() {
      /* A customer's own choice travels in the URL (?variant=), so only touch untouched loads. */
      if (/[?&]variant=/.test(location.search)) return;
      var radios = document.querySelectorAll('.product-form__input--pill input[type=radio]');
      var six = null;
      radios.forEach(function (r) { if (/\b6\s*x\s*6"/i.test(r.value) && !r.classList.contains('disabled')) six = r; });
      if (six && !six.checked) {
        six.checked = true;
        six.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    prettify(); preselect();
    /* Dawn re-renders the picker after variant changes: keep labels pretty. */
    new MutationObserver(function () { prettify(); }).observe(document.body, { subtree: true, childList: true });
  }

  /* ---------------- cart page ---------------- */
  function cart() {
    var done = false;
    css('.bk-cart-highlight{outline:2px solid ' + RED + ';outline-offset:6px;border-radius:8px;animation:bk-cart-pulse 1.2s ease-out 2}@keyframes bk-cart-pulse{0%{box-shadow:0 0 0 0 rgba(179,38,30,.45)}100%{box-shadow:0 0 0 14px rgba(179,38,30,0)}}');

    function findTab() {
      var els = document.querySelectorAll('button, label, div, span, a, li');
      for (var i = 0; i < els.length; i++) {
        var e = els[i];
        if (e.children.length === 0 && /^\s*store pickup\s*$/i.test(e.textContent || '')) return e;
      }
      return null;
    }
    function defaultToPickup() {
      if (done) return;
      var tab = findTab();
      if (!tab) return;
      var attrs = document.querySelector('input[name="attributes[Delivery Method]"]');
      if (attrs && attrs.value) { done = true; return; } /* customer already chose */
      tab.click(); done = true;
    }
    /* Bird mounts asynchronously; try for up to 8 seconds. */
    var tries = 0, t = setInterval(function () { defaultToPickup(); if (done || ++tries > 32) clearInterval(t); }, 250);

    /* Make a refused Check Out visible. */
    function errorNode() {
      var els = document.querySelectorAll('div, span, p, small');
      for (var i = 0; i < els.length; i++) {
        var e = els[i]; if (e.children.length) continue;
        if (/please (enter|select|choose|provide)/i.test(e.textContent || '') && e.offsetParent !== null) return e;
      }
      return null;
    }
    document.addEventListener('click', function (ev) {
      var b = ev.target && ev.target.closest && ev.target.closest('button, a, input[type=submit]');
      if (!b || !/check\s*out/i.test(b.textContent || b.value || '')) return;
      [150, 450, 900].forEach(function (d) {
        setTimeout(function () {
          var err = errorNode(); if (!err) return;
          var box = err.closest('form, section, div') || err;
          try { err.scrollIntoView({ block: 'center' }); } catch (e) { err.scrollIntoView(); }
          box.classList.remove('bk-cart-highlight'); void box.offsetWidth; box.classList.add('bk-cart-highlight');
          setTimeout(function () { box.classList.remove('bk-cart-highlight'); }, 3000);
          var msg = err.textContent.trim().replace(/\.?$/, '.');
          toast(msg + ' Choose a collection date to continue.', 'Show me', function () { try { err.scrollIntoView({ block: 'center' }); } catch (e) {} });
        }, d);
      });
    }, true);
  }

  function init() {
    if (tpl === 'product' && !document.querySelector('[data-bk-config]')) product();
    if (tpl === 'cart') cart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
